import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import globalPaymentServices from '../../../../../stores/global-payment-services';
import globalSettingsBranches from '../../../../../stores/global-settings-branches';
import { PaymentServiceWithVersionsResponseType } from '../../../../../api/types/payments/payment-template';
import { SettingsBranches } from '../../../../../api/types/settings/branches/settings-branches';
import CancelButton from '../../../../../component/ui/buttons/cancel-button/cancel-button';
import ApproveButtons from '../../../../../component/ui/buttons/approve-button/approve-buttons';
import { addPaymentServiceOperation } from '../operations/add-payment-service-operation';
import appApi from '../../../../../api/app-api';
import { observer } from 'mobx-react-lite';
import { UserSummaryType } from '../../../../../api/types/user/user-summary.type';

interface AddPaymentServiceDialogProps {
  visible: boolean;
  onHide: () => void;
  user: UserSummaryType;
}

export const AddPaymentServiceDialog: React.FC<AddPaymentServiceDialogProps> =
  observer(({ visible, onHide, user }) => {
    const [selectedService, setSelectedService] =
      useState<PaymentServiceWithVersionsResponseType | null>(null);
    const [selectedBranch, setSelectedBranch] =
      useState<SettingsBranches | null>(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
      const fetchPaymentServices = async () => {
        try {
          const response = await appApi.getAllPaymentServices();
          globalPaymentServices.services = response.data.body;
        } catch (error) {
          console.error('Error fetching payment services:', error);
        }
      };

      if (visible) {
        fetchPaymentServices();
      }
    }, [visible]);

    const handleApprove = async () => {
      if (!selectedService || !selectedBranch) {
        return;
      }

      // Use the latest price version (first in versions array)
      const latestPrice = selectedService.versions[0];

      await addPaymentServiceOperation(
        user.id,
        selectedBranch.id,
        selectedService.id,
        latestPrice.id,
        setLoading,
        onHide,
      );
    };

    const isApproveDisabled = !selectedService || !selectedBranch || loading;

    const branchTemplate = (option: SettingsBranches) => {
      return <div>{option.branchName}</div>;
    };

    return (
      <Dialog
        header="הוסף שרות תשלום לתלמיד"
        visible={visible}
        onHide={onHide}
        style={{ width: '800px' }}
        modal
      >
        <div style={{ marginBottom: '20px' }}>
          <label
            htmlFor="branch-dropdown"
            style={{ display: 'block', marginBottom: '8px' }}
          >
            בחר סניף:
          </label>
          <Dropdown
            id="branch-dropdown"
            value={selectedBranch}
            options={globalSettingsBranches.branches}
            onChange={(e) => setSelectedBranch(e.value)}
            itemTemplate={branchTemplate}
            optionLabel="branchName"
            placeholder="בחר סניף"
            style={{ width: '100%' }}
          />
        </div>

        <DataTable
          emptyMessage={
            <div style={{ textAlign: 'right' }}>לא נמצאו נתונים</div>
          }
          selectionMode="single"
          value={globalPaymentServices.services}
          selection={selectedService}
          onSelectionChange={(e) => {
            setSelectedService(
              e.value as PaymentServiceWithVersionsResponseType,
            );
          }}
          dataKey="id"
          tableStyle={{
            direction: 'rtl',
            marginTop: '16px',
          }}
        >
          <Column selectionMode="single" headerStyle={{ width: '3rem' }} />
          <Column
            style={{ textAlign: 'right', width: '200px' }}
            field="paymentServiceName"
            header="שם שרות"
          />
          <Column
            body={(data) => <div>₪{data.versions[0]?.price || 0}</div>}
            header="מחיר"
            style={{ textAlign: 'right' }}
          />
          <Column
            field="createdByName"
            header="נוצר ע״י"
            style={{ textAlign: 'right' }}
          />
          <Column
            field="createdAt"
            header="תאריך יצירה"
            style={{ textAlign: 'right' }}
            body={(rowData) =>
              rowData.createdAt
                ? new Date(rowData.createdAt).toLocaleDateString('he-IL')
                : ''
            }
          />
        </DataTable>

        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'left',
            marginTop: '20px',
            paddingBottom: '10px',
          }}
        >
          <CancelButton onClick={onHide} />
          <div style={{ width: '10px' }} />
          <ApproveButtons
            isLoading={loading}
            onClick={handleApprove}
            disabled={isApproveDisabled}
          />
        </div>
      </Dialog>
    );
  });
